import { render, staticRenderFns } from "./CompanyLocationCard.vue?vue&type=template&id=6c25b20e&scoped=true"
import script from "./CompanyLocationCard.vue?vue&type=script&lang=js"
export * from "./CompanyLocationCard.vue?vue&type=script&lang=js"
import style0 from "./CompanyLocationCard.vue?vue&type=style&index=0&id=6c25b20e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c25b20e",
  null
  
)

export default component.exports